import React from 'react';
import { Button, Card } from '@hz-design-system/web-ui';

import Skeleton from '../Skeleton/index';

import ComponentClasses from './SearchPreview.scss';

const SearchPreviewSkeleton = () => (
  <Card className={`${ComponentClasses.root}`}>
    <div className={ComponentClasses.header}>
      <Skeleton.Text type="short" />
    </div>
    <div className={ComponentClasses.previewImages}>
      <Skeleton.Block className={ComponentClasses.imageWrapper} />
      <Skeleton.Block className={ComponentClasses.imageWrapper} />
      <Skeleton.Block className={ComponentClasses.imageWrapper} />
      <Skeleton.Block className={ComponentClasses.imageWrapper} />
    </div>
    <Button.Tertiary className={ComponentClasses.button}>
      <Skeleton.Text type="short" />
    </Button.Tertiary>
  </Card>
);

export default SearchPreviewSkeleton;
